import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BaseUrl } from '../Page/common/BaseUrl';

export const checkForJobRequest = createAsyncThunk(
    'jobRequest/check',
    async (_, { getState }) => {
        const response = await axios.get(`${BaseUrl}/job/job-requests/check`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    }
);

export const respondToJobRequest = createAsyncThunk(
    'jobRequest/respond',
    async ({ queueId, status }, { getState }) => {
        const response = await axios.post(`${BaseUrl}/job/job-requests/${queueId}/respond`, {
            status
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    }
);

const jobRequestSlice = createSlice({
    name: 'jobRequest',
    initialState: {
        currentRequest: null,
        loading: false,
        error: null
    },
    reducers: {
        clearCurrentRequest: (state) => {
            state.currentRequest = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkForJobRequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(checkForJobRequest.fulfilled, (state, action) => {
                state.loading = false;
                state.currentRequest = action.payload;
            })
            .addCase(checkForJobRequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(respondToJobRequest.fulfilled, (state) => {
                state.currentRequest = null;
            });
    }
});

export const { clearCurrentRequest } = jobRequestSlice.actions;
export default jobRequestSlice.reducer;